import { showToast } from '@ditioas/web-ui';
import useHandleError from 'hooks/useHandleError';

export const showPlanningErrorToast = (message: string) =>
  showToast(message, {
    variant: 'danger',
    data: { position: 'bottom-center', duration: 2500 },
  });

const useHandlePlanningError = () => {
  const handleError = useHandleError();

  return (error: any) => {
    if (!error.response && typeof error.message === 'string') {
      showPlanningErrorToast(error.message);
    } else {
      handleError(error);
    }
  };
};

export default useHandlePlanningError;
